import { useEffect, useRef } from 'react';
import usePolling from './usePolling';
import { useNotificationSocket } from '@/contexts/NotificationSocketContext';

// Refetches `fetchFn` the moment a matching event arrives over the shared
// notification WebSocket (see NotificationSocketContext). Also keeps a REST
// poll running as a fallback/reconciliation net — at `activeIntervalMs` while
// the socket isn't connected (today, since the backend hasn't shipped the
// WebSocket yet — this keeps current polling behaviour unchanged), or a much
// slower `idleIntervalMs` once the socket is live, so a message-shape
// mismatch with the backend can never cause silent staleness.
const useLiveNotifications = (fetchFn, eventTypes, activeIntervalMs, idleIntervalMs = 300000) => {
  const socket = useNotificationSocket();
  const fetchRef = useRef(fetchFn);
  fetchRef.current = fetchFn;

  useEffect(() => {
    if (!socket) return undefined;
    return socket.subscribe((payload) => {
      if (eventTypes.includes(payload?.type)) {
        fetchRef.current();
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket]);

  usePolling(() => {
    fetchRef.current();
  }, socket?.connected ? idleIntervalMs : activeIntervalMs);
};

export default useLiveNotifications;
